// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__DTlas","alert":"SettungsInbox_alert__KqE70"};